/**
 * Popup per i messaggi di errore restituiti dal server.
 * Il messaggio viene scritto anche nel box fisso del form, così resta leggibile dopo la chiusura.
 */
let dialog = null;

function getDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'error-dialog';
    dialog.innerHTML =
        '<div class="error-dialog__inner">' +
        '<div class="error-dialog__message" role="alert"></div>' +
        '<form method="dialog"><button type="submit" class="thom-form__submit">' + wp.i18n.__('OK', 'cadelbosco') + '</button></form>' +
        '</div>';
    // tap/click sullo sfondo: chiude (il contenuto è dentro __inner, quindi il target è il dialog solo fuori dal riquadro)
    // link nel messaggio: chiude, perché con Barba la pagina cambia senza ricaricare il body (e il popup resterebbe aperto)
    dialog.addEventListener('click', function (event) {
        if (event.target === dialog || event.target.closest('a')) dialog.close();
    });
    document.body.appendChild(dialog);
    return dialog;
}

export default function showFormError(message, $box) {
    $box.html(message);
    const d = getDialog();
    if (typeof d.showModal !== 'function') return; // browser molto vecchi: resta il box fisso
    d.querySelector('.error-dialog__message').innerHTML = message;
    if (!d.open) d.showModal();
}